import React from "react";

type VisibilityProps = {
  visible: boolean;
  children: React.ReactNode;
}

export default function Visibility({
  visible,
  children,
}: VisibilityProps): JSX.Element {
  return visible ? <>{children}</> : <></>;
}